module.exports = __webpack_public_path__ + "img/lawContrant1.98082fec.png";